import {
  CompanyFactKey,
  CompanyFactSchemaVersion,
  ConflictStrategy,
  type FactKeyConfig,
} from '../core'

export const ARRIVAL_GUIDELINES_KEY_CONFIG: Partial<
  Record<CompanyFactKey, FactKeyConfig>
> = {
  [CompanyFactKey.ARRIVAL_GUIDELINES_PARKING]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Parking',
    conflictStrategy: ConflictStrategy.APPEND,
  },
  [CompanyFactKey.ARRIVAL_GUIDELINES_ENTRANCE]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Entrance',
  },
  [CompanyFactKey.ARRIVAL_GUIDELINES_CONTACT_SUPERVISOR]: {
    schemaVersion: CompanyFactSchemaVersion.CONTACT_V1,
    displayName: 'Contact Supervisor',
  },
  [CompanyFactKey.ARRIVAL_GUIDELINES_FIRST_DAY]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'First Day Expectations and Training',
    conflictStrategy: ConflictStrategy.APPEND,
    purposeTooltip:
      'First-day expectations and training instructions for workers (e.g., "arrive 15 min early on day one for safety briefing", "report to HR for paperwork before starting", "facility tour required on first day"). Specifically for day-one orientation, distinct from general arrival logistics and from notes.',
  },
  [CompanyFactKey.ARRIVAL_GUIDELINES_NOTES]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Notes',
    conflictStrategy: ConflictStrategy.APPEND,
  },
}
